// Abu Dhabi - routine AC cleaning. Written separately from the Dubai page.
const content = {
    slug: 'ac-cleaning',
    title: (c) => `AC Cleaning Abu Dhabi from ${c.money(c.tables.general[0].wall)} | Villas & Apartments`,
    description: (c) =>
        `AC cleaning in Abu Dhabi from ${c.money(c.tables.general[0].wall)} per split unit. Whole-villa bookings, island towers and ducted units. Upfront prices.`,
    eyebrow: 'Abu Dhabi · AC cleaning',
    h1: 'AC Cleaning in Abu Dhabi',
    lead: (c) =>
        `A routine clean every few months keeps filters, coils and drains clear through Abu Dhabi's long cooling season. ${c.money(c.tables.general[0].wall)} for one split unit, ${c.money(c.tables.general[4].wall)} for five.`,
    image: 'blog/living/aircon-service.jpg',
    imageAlt: 'Routine AC cleaning in an Abu Dhabi villa',
    facts: ['Whole-villa bookings', 'Split, ducted, cassette', 'Every 3-4 months'],
    priceTitle: 'Cleaning prices',
    priceIntro: 'The more units on one visit, the lower the price per unit - five split units cost about the same per unit as a single filter service elsewhere.',
    panel: { type: 'servicing', services: ['general'], defaultMount: 'Wall' },
    sections: [
        {
            title: 'Island homes vs mainland homes',
            cards: [
                { title: 'Reem, Saadiyat, Yas, Corniche', body: 'Humidity is the problem. Expect wet drain trays and early mould on coils. Ask the technician to pay extra attention to the drain line and tray.' },
                { title: 'Khalifa City, MBZ, Al Reef', body: 'Dust and heat are the problem. Filters clog fast and outdoor units collect sand. Ask for the outdoor coil to be brushed on every visit.' },
            ],
            cardColumns: 2,
        },
        {
            // Target of the hero card's Service Details link
            id: 'included',
            title: 'What happens during the clean',
            tone: 'muted',
            steps: [
                { title: 'Quick check', body: 'The technician runs each unit and notes airflow, noise and any leaks before starting.' },
                { title: 'Filters and grilles', body: 'Filters and return grilles are removed, washed and dried.' },
                { title: 'Coil, blower, tray', body: 'Coil face brushed and rinsed, blower wheel wiped, drain tray cleaned and the line flushed.' },
                { title: 'Outdoor unit', body: 'For split systems, the outdoor coil is brushed off and the fan checked.' },
                { title: 'Report', body: 'You get a short note of anything that needs more than a clean - a coil wash, gas or a part - with the price, before anything extra is done.' },
            ],
        },
    ],
    faqs: [
        {
            question: 'How much is AC cleaning in Abu Dhabi?',
            answer: (c) => `${c.money(c.tables.general[0].wall)} for one split unit, ${c.money(c.tables.general[2].wall)} for three and ${c.money(c.tables.general[4].wall)} for five. Ducted units start at ${c.money(c.tables.general[0].ducted)}.`,
        },
        {
            question: 'How long does it take to clean all the units in a villa?',
            answer: 'Around 40 to 60 minutes per unit. A six-unit villa is usually done in a morning by a two-person team.',
        },
        {
            question: 'Do I need to book the outdoor units separately?',
            answer: 'No. Brushing off the outdoor coil of a split system is part of the cleaning. A full chemical clean of an outdoor unit is a separate job.',
        },
    ],
    schema: {
        name: 'AC Cleaning in Abu Dhabi',
        serviceType: 'Air conditioner cleaning',
        offers: (c) => [
            { name: 'AC cleaning, 1 split unit', price: c.tables.general[0].wall },
            { name: 'AC cleaning, 3 split units', price: c.tables.general[2].wall },
            { name: 'AC cleaning, 5 split units', price: c.tables.general[4].wall },
            { name: 'AC cleaning, 1 ducted unit', price: c.tables.general[0].ducted },
        ],
    },
}

export default content
